// Services
import productService from "@/app/services/main/product/product-service.js";

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { shoppingMixins } from "@/app/mixins/components/shopping-mixins";
import { userMixins } from "@/app/mixins/modules/user-mixins.js";
import { switchPetMixins } from "@/app/mixins/modules/switch-pet-mixins";

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants";

export default {
    name: "ProductsContainer",
    mixins: [toastMessageMixins, shoppingMixins, userMixins, switchPetMixins],
    data() {
        return {
            isAPILoading: false,
            plans: [],
            currentPage: null
        };
    },
    created() {
        if (window.location.pathname) {
			this.currentPage = window.location.pathname.substring(1)
		}
        this.getBundlesLowestPrice();
        this.setCartCount(this.getActivePet.id);
        this.setPendingOrderCount(this.getActivePet.id);
    },
    methods: {
        refreshActivePetData() {
            this.getBundlesLowestPrice();
            this.setCartCount(this.getActivePet.id);
            this.setPendingOrderCount(this.getActivePet.id);
        },
        preFilterProductListing(productType) {
            this.$router.push(`/products/product-list?type=${productType}`);
        },
        getBundlesLowestPrice() {
            this.isAPILoading = true;

            productService.getBundlesLowestPrice(this.getActivePet.id).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.plans = res.data.data;
                    this.isAPILoading = false;
                } else {
                    const { ERROR_GET_PRODUCT_LIST } = this.toastMessages.product();
                    this.showAPIErrorToast(ERROR_GET_PRODUCT_LIST, res);
                }
            });
        },
    },
};
